import React, { Component } from 'react'
import './styles.css'
import Logo from '../../img/banner_logo.png'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { login } from '../../store/actions/user'
import { setserver } from '../../store/actions/server'
import { apiEmployee } from '../../services/apiamrg'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'

import { NOME_EMPRESA } from '../../config'
import Alert from '../../components/alert'

const estadoInicial = {
    //login: 'rgfumigacao',
    //senha: 'r10gr4nd3fumig@c@o',
    id: 0,
    login: '',
    senha: '',
    confirmaSenha: '',
    login2: '',
    nome: '',
    token: '',
    redirect: false,
    token: '',
    online: false,
    operadores: [],

    alert: {type: '', msg: ''}
}

class Cadastro extends Component {

    state = {
        ...estadoInicial
    }

    signin = async () => {

        await apiEmployee.post(`registracliente`, {
            login: this.state.login?.trim(),
            cpf: this.state.cpf?.replace(/[^0-9]/gi, ''),
            cnpj: this.state.cnpj?.replace(/[^0-9]/gi, ''),
            senha: this.state.senha,
            nome: this.state.nome?.trim(),
        }).then(
            async res => {
                if (res.data) {
                    confirmAlert({
                        customUI: ({ onClose }) => {
                            return (
                                <div className='custom-ui text-center'>
                                    <h1>{NOME_EMPRESA}</h1>
                                    <h3>Cadastro realizado!</h3>
                                    <p>Você poderá logar assim que seu cadastro for aprovado!</p>
                                    <button
                                        style={{ marginRight: 5 }}
                                        className="btn btn-success w-50"
                                        onClick={
                                            async () => {
                                                onClose()
                                            }
                                        }
                                    >
                                        Ok
                                    </button>
                                </div>
                            )
                        }
                    })
                    this.setState({ redirect: true })
                } else {

                    confirmAlert({
                        customUI: ({ onClose }) => {
                            return (
                                <div className='custom-ui text-center'>
                                    <h1>{NOME_EMPRESA}</h1>
                                    <p>Falha no cadastro, verifique seus dados e tente novamente!</p>
                                    <button
                                        style={{ marginRight: 5 }}
                                        className="btn btn-danger w-50"
                                        onClick={
                                            async () => {
                                                this.setState({alert: {type: 'error', msg: 'Erro no cadastro'}});
                                                onClose()
                                            }
                                        }
                                    >
                                        Ok
                                    </button>
                                </div>
                            )
                        }
                    })

                }
            },
            async err => {
                console.error(err);
                this.setState({ alert: { type: 'error', msg: 'Erro no Cadastro' } });
            }
        )
    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.signin()
        }
    }

    render() {
        const validations = []
        validations.push(this.state.cnpj && this.state.cnpj?.replace(/[^0-9]/gi, '').trim().length == 14);
        validations.push(this.state.cpf && this.state.cpf?.replace(/[^0-9]/gi, '').trim().length == 11);
        validations.push(this.state.login && this.state.login?.trim().length >= 4);
        validations.push(this.state.nome && this.state.nome.trim().length >= 4);
        validations.push(this.state.senha && this.state.senha.trim().length >= 4);
        validations.push(this.state.senha == this.state.confirmaSenha);

        //o formulário só será válido se todas as validações forem verdadeiras, com este reduce implementado
        const validForm = validations.reduce((t, a) => t && a)

        return (
            <div style={{ backgroundColor: "#DE3338", minHeight: "100vh" }}>
                {this.state.redirect &&
                    <Redirect to={'/'} />
                }
                <div className='row'>
                    <div className='col-12 containerlogoadmin'>
                        <img src={Logo} className='img-fluid logoadmin' />
                    </div>

                    <Alert alert={this.state.alert} setAlert={(alert) => this.setState({ alert })} />

                    <div className='containerinputslogin col-12'>
                        <div className='containerinputloginmesmo' style={{height: 'auto', paddingBottom: 15}}>
                            <div className='continputlabel'>
                                <span> CNPJ da empresa:</span>
                                <input type='text' placeholder={"00.000.000/0000-00"} value={this.state.cnpj} onChange={(e) => this.setState({ cnpj: e.currentTarget.value })} onKeyPress={this.handleKeyPress} />
                            </div>

                            <div className='continputlabel'>
                                <span> CPF:</span>
                                <input type='text' placeholder={"000.000.000-00"} value={this.state.cpf} onChange={(e) => this.setState({ cpf: e.currentTarget.value })} onKeyPress={this.handleKeyPress} />
                            </div>

                            <div className='continputlabel'>
                                <span> Login:</span>
                                <input type='text' placeholder={"exemplo@email.com"} value={this.state.login} onChange={(e) => this.setState({ login: e.currentTarget.value })} onKeyPress={this.handleKeyPress} />
                            </div>

                            <div className='continputlabel'>
                                <span> Nome:</span>
                                <input type='text' placeholder={"XXXXXXXX"} value={this.state.nome} onChange={(e) => this.setState({ nome: e.currentTarget.value })} onKeyPress={this.handleKeyPress} />
                            </div>

                            <div className='continputlabel'>
                                <span> Senha:</span>
                                <input type='password' placeholder={"•••••"} value={this.state.senha} onChange={(e) => this.setState({ senha: e.currentTarget.value })} onKeyPress={this.handleKeyPress} />
                            </div>

                            <div className='continputlabel'>
                                <span> Confirmar Senha:</span>
                                <input type='password' placeholder={"•••••"} value={this.state.confirmaSenha} onChange={(e) => this.setState({ confirmaSenha: e.currentTarget.value })} onKeyPress={this.handleKeyPress} />
                            </div>

                            <button type='button' className='butaoadminlogar' disabled={!validForm} onClick={() => validForm ? this.signin() : {}}> Cadastrar</button>

                        </div>
                        <div className="nao_possui_login">Já é cadastrado? <a href="/">Faça login</a></div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onLogin: user => dispatch(login(user)),
        onSetServidor: servidor => dispatch(setserver(servidor))
    }
}

export default connect(null, mapDispatchToProps)(Cadastro)